
import { useState, useEffect, useRef } from 'react';
import { wsUrl } from '../utils/api';

export function useWS(user) {
  const [status, setStatus] = useState('connecting');
  const [messages, setMessages] = useState([]);
  const wsRef = useRef(null);
  
  useEffect(() => {
    if (!user) return;
    const url = wsUrl(); 
    if (!url) return;
    
    const ws = new WebSocket(url); 
    wsRef.current = ws;
    
    ws.onopen = () => { 
      setStatus('connected'); 
      ws.send(JSON.stringify({ type: 'subscribe', user_id: user.id })); 
    };
    
    ws.onmessage = (ev) => { 
      setMessages((m) => [...m, JSON.parse(ev.data)]); 
    };
    
    ws.onclose = () => setStatus('disconnected');
    ws.onerror = () => setStatus('error');
    
    return () => { 
      try { ws.close(); } catch {} 
    };
  }, [user?.id]);
  
  return { status, messages };
}
